import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { CourseSchema, DBCourseSchema } from './schemas';

export const CourseCodecConfig: TransformerConfig<typeof CourseSchema, typeof DBCourseSchema> = {
  name: 'Course',
  clientSchema: CourseSchema,
  dbSchema: DBCourseSchema,
  // No transformers needed - CourseSchema and DBCourseSchema have identical structures
  // All fields pass through unchanged
  transformers: [],
};

export const encodeCourseToDb = createEncodeToDbFn(CourseCodecConfig);
export const decodeCourseFromDb = createDecodeFromDbFn(CourseCodecConfig);
